import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import { IAppointmentLocationsOrganizersDatasource } from '../datasources/appointment_location_staff_datasource';
import { IAppointmentReasonTypeDatasource } from '../datasources/appointment_reason_type_datasource';
import { AppointmentsAvailableTimesDatasource } from '../datasources/appointments_available_times_datasource';
import { ConfirmAppointmentModel } from '../models/confirm_appointment_model';
import { AppointmentsAvailableTimesServant } from '../servants/appointments_available_times_servant';
import { AppointmentsTabsConfiguration } from '../servants/appointments_tabs_configuration';
import {
  IAppointmentType,
  IAvailableTime,
  IStudentService,
  IStudentServiceCategory
} from '../types/appointment_interfaces';
import { ILocation, ILocationCourses, IOrganizer } from '../types/appt_interfaces';
import { TAlternateAppointmentTimesUsersource } from '../usersources/alternate_appointment_times_usersource';
import { TAppointmentAvailableTimesUsersource } from '../usersources/appointment_available_times_usersource';
import { TAppointmentLocationsOrganizersUsersource } from '../usersources/appointment_location_staff_usersource';
import { TAppointmentReasonUsersource } from '../usersources/appointment_reason_usersource';

angular
  .module('capability-ng-appointments')
  .factory(
    'clearAllAppointmentsDataSourcesCommand',
    (
      defineCommand: IDefineCommand,
      ngAppointmentsAvailableTimesDatasource: AppointmentsAvailableTimesDatasource,
      ngAppointmentsTabsConfiguration: AppointmentsTabsConfiguration,
      ngAppointmentsAvailableTimesServant: AppointmentsAvailableTimesServant,
      ngAppointmentReasonTypeDatasource: IAppointmentReasonTypeDatasource,
      ngAlternateAppointmentTimesUsersource: TAlternateAppointmentTimesUsersource,
      ngAppointmentReasonUsersource: TAppointmentReasonUsersource,
      appointmentCampaignConstant: any,
      ngAppointmentAvailableTimesUsersource: TAppointmentAvailableTimesUsersource,
      ngConfirmAppointmentModel: ConfirmAppointmentModel,
      QueryMediator: IQueryMediator,
      ngAppointmentLocationsOrganizersUsersource: TAppointmentLocationsOrganizersUsersource,
      ngAppointmentLocationsOrganizersDatasource: IAppointmentLocationsOrganizersDatasource
    ): ICommand => {
      return defineCommand('clearAllAppointmentsDataSourcesCommand', (deferred: ng.IDeferred<any>): void => {
        ngAppointmentReasonTypeDatasource.clear();
        ngConfirmAppointmentModel.initializeConfirmAppointmentReminderOptions();
        appointmentCampaignConstant.isAppointmentCampaign = false;
        appointmentCampaignConstant.campaignInvitationId = 0;
        ngAppointmentReasonUsersource.set('selectedCategory', {} as IStudentServiceCategory);
        ngAppointmentReasonUsersource.set('selectedService', {} as IStudentService);
        ngAppointmentReasonUsersource.set('selectedType', {} as IAppointmentType);
        ngAlternateAppointmentTimesUsersource.availability = '';
        ngAlternateAppointmentTimesUsersource.set('selectedLocation', {} as ILocation);
        ngAppointmentAvailableTimesUsersource.set('selectedTime', {} as IAvailableTime);
        ngAppointmentLocationsOrganizersUsersource.set('selectedLocation', {} as ILocation);
        ngAppointmentLocationsOrganizersUsersource.set('selectedCourse', {} as ILocationCourses);
        ngAppointmentLocationsOrganizersUsersource.set('selectedOrganizers', [] as IOrganizer[]);
        ngAppointmentLocationsOrganizersDatasource.clear();
        ngAppointmentsAvailableTimesDatasource.clear();
        ngAppointmentAvailableTimesUsersource.clear();
        ngAppointmentsAvailableTimesServant.clearWeekOffSet();
        QueryMediator.runQueries(ngAppointmentReasonTypeDatasource, ngAppointmentsAvailableTimesDatasource);
        ngAppointmentsTabsConfiguration.resetToDefault();
        deferred.resolve();
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/commands/clear_all_appointments_datasources.ts